export var DriveType;
(function (DriveType) {
    DriveType["FRONT_WHEEL_DRIVE"] = "FRONT_WHEEL_DRIVE";
    DriveType["REAR_WHEEL_DRIVE"] = "REAR_WHEEL_DRIVE";
    DriveType["ALL_WHEEL_DRIVE"] = "ALL_WHEEL_DRIVE";
    DriveType["SHAFT_DRIVE"] = "SHAFT_DRIVE";
    DriveType["BELT_DRIVE"] = "BELT_DRIVE";
    DriveType["CHAIN_DRIVE"] = "CHAIN_DRIVE";
    DriveType["UNKNOWN"] = "UNKNOWN";
})(DriveType || (DriveType = {}));
//# sourceMappingURL=driveType.js.map